import styled from '@emotion/styled';

export const Root = styled.a`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 8px 16px;
  cursor: pointer;
`;

export const ImageContainer = styled.div`
  margin-right: 12px;
`;

export const DescriptionContainer = styled.div`
  flex: 1;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-right: 15px;
`;
